/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntroductionInquiryDto } from '../../models/introduction-inquiry-dto';

export interface IntroductionInquiryControllerFindAll$Params {
}

export function introductionInquiryControllerFindAll(http: HttpClient, rootUrl: string, params?: IntroductionInquiryControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IntroductionInquiryDto>>> {
  const rb = new RequestBuilder(rootUrl, introductionInquiryControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<IntroductionInquiryDto>>;
    })
  );
}

introductionInquiryControllerFindAll.PATH = '/api/introduction-inquiry';
